module.exports = __webpack_public_path__ + "img/home-saude.e3af1004.svg";